if (!customElements.get('product-media')) {
  class productMedia extends HTMLElement {
    constructor() {
      super();

      this.swiper();
      this.fancybox();
    }

    swiper() {

      // Check if Swiper exists
      if (typeof Swiper == 'undefined') {
        return false;
      }

      // Get swiper element
      this.swiperElement = this.querySelector('[data-product-media-swiper]');

      // Swiper options
      this.swiperOptions = {
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
        direction: 'horizontal',
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }

      // Get options from element data and combine with this.swiperOptions
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.swiperOptions = {
          ...this.swiperOptions,
          ...dataOptions,
        };
      }

      this.init = false;
      this.initSwiper();

      window.addEventListener("resize", this.initSwiper.bind(this));
    }

    initSwiper() {
      if (window.innerWidth < 768 || this.swiperOptions.quickshop) {

        if (!this.init) {
          this.init = true;
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

          // Rebuid Swiper in design mode
          if(Shopify.designMode && this.swiperInstance) {
            window.addEventListener('shopify:section:load', () => {
              this.swiperInstance.update();
            });
          }
        }
      } else if (this.init) {
        this.swiperInstance.destroy();
        this.init = false;
      }
    }

    /*
     * Create fancybox
    */
    fancybox() {

      // Check if Fancybox exists
      if (typeof Fancybox == 'undefined') {
        return false;
      }

      Fancybox.bind("[data-fancybox]", {
        animated: false,
        showClass: false
      });

    }

  }

  window.productMedia = productMedia;

  customElements.define('product-media', productMedia);
}

if (!customElements.get('product-media-nav')) {
  class productMediaNav extends HTMLElement {
    constructor() {
      super();

      this.initNavElements();
    }

    initNavElements() {

      const self = this;
      this.querySelectorAll('a').forEach(function(el){
        el.addEventListener('click', function(event) {
          event.preventDefault();
          self.scrollToId(el.getAttribute('href'));
        });
      })


      this.images = document.querySelectorAll('.product-media__images .product-media__item');
      this.getTreshold();
      window.addEventListener("resize", this.getTreshold.bind(this));

    }

    getTreshold() {
      const h = this.images[0].offsetHeight * 1.3;
      this.threshold = Math.min(window.innerHeight / h, 1 );

      const observer = new IntersectionObserver((e)=> {this.handleIntersection(e)}, {
        threshold: this.threshold,
      });

      this.images.forEach(image => observer.observe(image));
    }

    handleIntersection(entries) {
      entries.map((entry) => {
        const id = entry.target.id;
        const navEl = document.querySelector(`a[href="#${id}"]`)

        if (entry.isIntersecting) {
          this.querySelectorAll('a.active').forEach( el => {
            el.classList.remove('active');
          })
          navEl.classList.add('active');
        }
      });
    }

    scrollToId(id) {
      const offsetPosition = Math.max(document.querySelector(id).getBoundingClientRect().top + document.documentElement.scrollTop - 158, 0);
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }

    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
          rect.top >= 0
      );
    }
  }

  window.productMediaNav = productMediaNav;

  customElements.define('product-media-nav', productMediaNav);
}